const ReimbursementLevel = ({ needsLevels = 3, labels = {}, translation }) => {
  const levels = Array.from({ length: needsLevels }, (_, i) => {
    const value = i + 1;
    return {
      label:
        labels[String(value)] || `${translation.NEEDS.DEFAULT_LEVEL} ${value}`,
      value,
      description: "",
    };
  });

  return (
    <div className="b2c-static-slider__wrapper">
      {levels.map(({ label, value, description }) => (
        <div className="b2c-static-slider" key={value}>
          <div className="b2c-static-slider--bar">
            <div
              className="b2c-static-slider--track"
              style={{ width: `${(value / needsLevels) * 100}%` }}
            />
            <div
              className="b2c-static-slider--circle"
              style={{ left: `${(value / needsLevels) * 100}%` }}
            >
              <div className="b2c-static-slider--marker">{label}</div>
              <div className="b2c-static-slider--thumb" />
            </div>
            <div className="b2c-static-slider--divider" />
          </div>
          <div className="b2c-static-slider--description">
            <span>
              {translation.NEEDS.LEVEL_LABEL} {label} :
            </span>
            <p>{description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ReimbursementLevel;
